export const uploadtype = () => {};
